<template>
  <fragment>
    <slot v-if="topics.binded" />
    <b-loading v-else-if="topics.loading" active :is-full-page="false" />
    <mc-error-layout
      v-else-if="topics.error"
      message="Failed to load topics"
      :retry-fn="getTopics"
    />
  </fragment>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  computed: {
    ...mapState(['topics'])
  },
  methods: {
    ...mapActions('topics', ['getTopics'])
  },
  mounted() {
    this.getTopics();
  }
};
</script>
